import * as Types from './types.generated';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ResendRegisterConfirmEmailMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type ResendRegisterConfirmEmailMutation = { __typename?: 'Mutation', resendRegisterConfirmEmail: boolean };


export const ResendRegisterConfirmEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resendRegisterConfirmEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendRegisterConfirmEmail"}}]}}]} as unknown as DocumentNode<ResendRegisterConfirmEmailMutation, ResendRegisterConfirmEmailMutationVariables>;